<template>
  <div id="orderList" >
	  <Tabbar msg="/orderList" />
	  <plugin />
	  <Pay  ref="edit" v-if='orderPayShow' :orderid='orderPayid' />
	<div class="app-top-border"></div>
	
    	<div class='orders' @touchstart='orderTouchstart'  @touchend='orderTouchend'>
      	<div class="order"    v-for='(item,index) in orderList'  @click='toOrderDetail(item.id)' :id='orderListLength==index?"lastOrder":""'>
   
                  <div class="status" v-if='item.order_status==0'>待支付</div>        
                  <div class="status" v-else-if='item.order_status==7'>待发货</div>
                  <div class="status" v-else-if='item.order_status==2'>已发货</div>
                  <div class="status cancel" v-else-if='item.order_status==-1'>已取消</div>
                  <div class="status cancel" v-else-if='item.order_status==4'> 申请退货</div>
                  <div class="status success" v-else-if='item.order_status==3'>已送达</div>
                  <div class="status cancel" v-else-if='item.order_status==5'> 已退款</div>
                  <div class="status cancel"  v-else-if='item.order_status==6'> 拒绝退货退款</div>
		  <div class="status"  v-else>定制中</div>
                  
                  <div class="order-number">
                      订单编号：{{item.order_no}}
                  </div>
	
            
                  <div class="product" v-if='!item.cart_ids' data-name='老订单'>
                      <div class="thumb">
                          <img :src="item.planThumb_url" />
                      </div>
                      <div class="info">
                          <div class="name" v-if='item.meal_name'>{{item.meal_name}}</div>
                          <div class="name" v-else>你的橘袋</div>
                          <div class="time">{{item.buy_days}}天</div>
                          <div class="price" ><text></text> {{item.need_pay}}元</div>
                      </div>
                  </div>

             	 <div v-else @click='toOrderDetail(item.id)'>
                   <div class="orderproduct"   v-for='cartItem in item.cart_list' data-name='新订单'>
                      <div class="thumb">
                          <img :src="cartItem.img" />
                      </div>
                      <div class="info">
                          <div class="name">{{cartItem.name}}{{cartItem.advance_str}}</div>
                          <div class="time" v-if='cartItem.source==2'>{{cartItem.num}}套</div>
 			                <div class="time" v-else>{{cartItem.plan_title}}</div>
                          <div class="price" ><text></text> {{cartItem.price}}元</div>
                      </div>
                  </div>
		        </div>
            		
                        <div class="btns"  v-if='item.order_status==0'>
                            <div class="app-btn btn-sure"  v-on:click.stop='payOldOrder(item.id)'>确认支付</div>
                            <!-- <div class="app-btn btn-normal"  v-on:click.stop='cancelOrder1(item.id)'>取消订单</div> -->
                        </div>
                       <div class="btns"  v-else-if='item.order_status==2'>
                            <!-- <div class="app-btn btn-sure" v-on:click.stop='deliveryOrder1(item.id)'>确认收货</div> -->
                            <div  class="app-btn btn-normal"  v-on:click.stop='seeLogistics(item.id)'>订单状态</div>
                        </div>
                        <div class="btns"  v-else-if='item.order_status==3'>
                          <div  class="app-btn btn-normal"  v-on:click.stop='seeLogistics(item.id)'>订单状态</div>
                        </div>
                        <div class="btns"  v-else-if='item.order_status==4'>
                          <div  class="app-btn btn-normal"  v-on:click.stop='seeLogistics(item.id)'>订单状态</div>
                        </div>
			 <div class="btns"  v-else-if='item.order_status==5'>
                          <div  class="app-btn btn-normal"  v-on:click.stop='seeLogistics(item.id)'>订单状态</div>
                        </div>
                        <div class="btns"  v-else-if='item.order_status==-1'>
							<div  class="app-btn btn-normal"  v-on:click.stop='seeLogistics(item.id)'>订单状态</div>
                          <!-- <div class="app-btn btn-normal"  v-on:click.stop='delOrder1(item.id)'>删除订单</div> -->
                        </div>
			 <div class="btns"  v-else>    
                           
                            <div  class="app-btn btn-normal" v-on:click.stop='seeLogistics(item.id)'>订单状态</div>
 
                        </div>
                
     
     <div class='nullBox' v-if='item.hide'></div> 
</div>

     <div class='showBottomBox' v-if='orderList.length>0'>
		 <div class='showBottomafter'></div>
			 <div class='showBottom'>没有更多的订单记录了</div>
		  <div class='showBottomafter'></div>
		 </div>
    </div> 

	<div class='noOrder'  v-if='orderList.length<1&&nullList'>
		<div class='noOrderTitle'>什么都没有</div>
		<div class='noOrderMsg'>你还没有任何订单</div>
		<div class='app-btn app-btn--shadow' @click='toQuestions'>马上测一次</div>
	<!-- 	<div>自选产品</div> -->
	</div>

  </div>
</template>

<script>

import Tabbar from '@/components/tabbar.vue'
import plugin from '@/components/plugin.vue'
import Pay from '@/popup/Pay.vue'
export default {
  name: 'orderList',
  components: {
      Tabbar,
	  plugin,
	  Pay,
  },
  data() {
      return {
      	orderList:[],
		showBottom:true,
		page:1,
		lastPage:2,
		noMore:false,
		orderPayShow:false,
		orderPayid:0,
		nullList:false,    //是否允许显示空列表
      }
    },
    computed: {
      
    },
    mounted() {
     
    },
    created(){
		this.getOrderList()
    },
    methods:{
		toQuestions(){
		 this.$router.push({name: 'beforeQuestion'});
		},
		// 获取订单列表
	    getOrderList(){
	    	let that =this
	    	console.log(this.$store.state.member_id )
	      this.axios({
	                  method: 'post',
	                  url:"Order/getOrderList",
	                  data:{
							member_id:this.$store.state.member_id,
							page:this.page, 
	                  }
	                }).then(res=>{
						
						let _orderList = that.orderList
						 _orderList = _orderList.concat(res.data.orderList.data)
	                   console.log(res)
					   for (let i = 0; i < _orderList.length;i++){
					         if (_orderList[i].cart_ids){
					           _orderList[i].cart_list.forEach((item)=>{
					             item.price = Number(item.need_pay) * Number(item.num)
					           })
					         }
					     }   
					  that.lastPage = res.data.orderList.last_page
					  that.page = res.data.orderList.current_page
					  that.orderListLength = (_orderList.length-1)||0 
			          that.orderList = _orderList 
					  that.nullList =true
          		})
	},
   seeLogistics(event){
	this.$router.push({
					name: 'orderDetail',
					params: { "orderid":event,"log":1}
					});
   },
   payOldOrder(e){
	   console.log("支付老订单")
	    this.orderPayid = e
		this.orderPayShow = true
		
   },
   cancelOrder1(e){

   },
   delOrder1(e){
	   
   },
   toOrderDetail(event){
	   this.$router.push({
	   						name: 'orderDetail',
	   						params: { "orderid":event}
	   						});
   },
	orderTouchstart(e){
		
		this.touchStartY = e.changedTouches[0].clientY
	},
	orderTouchend(e){
		this.touchEndY = e.changedTouches[0].clientY
		this.orderTouchFn()
	},
	orderTouchFn(){
		if(this.touchStartY-this.touchEndY<50)return
		let  Y = $('#lastOrder').position().top
		if( Y < document.body.clientHeight ){
			this.moreOrderlist()
		}
		
	},
	// 加载更多
	moreOrderlist(){
		console.log("加载更多")
		console.log(this.page<this.lastPage)
		if(this.page<this.lastPage){
			this.page = Number(this.page) + 1
			this.getOrderList()
		}else{
			this.noMore = true
		}
	},
	// 关闭支付
	closeOrderPay(id){
		this.orderPayid = 0
		this.orderPayShow=false
		console.log(id)
		this.toOrderDetail(id)
	},
	// 确认收货
	deliveryOrder(eve){
	    let that = this
		this.axios({
		            method: 'post',
		            url:"Order/receiveOrder",
		            data:{
							order_id: eve
		            }
		          }).then(res=>{
	   
	      let _orderList = that.data.orderList
	      _orderList.forEach((item, index, array) => {
	        if (item.id == eve) {
	          item.order_status = 3
			   that.$set(that.orderList, index, item)
	        }
	      })
	 
	
	      
	    })
	   
	  },
  }
}
</script>
<style>
#orderList{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
  text-align: left;
overflow-y: auto;
}
#orderList::-webkit-scrollbar {display:none}
#orderList2{
	overflow: hidden;
}
#orderList .orders {
    padding: 0.4rem;
}
#orderList .orders .order {
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(194,94,77,0.24);
    border-radius: 10px;
    padding: 0.24rem 0.27rem 0.4rem 0.27rem;
    margin-bottom: 0.4rem;
    position: relative;
    overflow: hidden;
    transition: all 3s;
}
#orderList .orders .order .status {
    position: absolute;
    right: 0;
    top:24rpx;
    color: #C25E4D;
    padding:0 0.25rem;
    border-radius: 0 0px 0 0.52rem;
}
#orderList .orders .order .status.cancel {
    /* background: #E6E6E6; */
    color: #9B9B9B;
}
#orderList .orders .order .status.success {
    /* background: #DDE3DB; */
    color: #5C8680;
}
#orderList .order-number{
  margin-bottom: 0.3rem;
}
#orderList .orders .order .orderproduct {
    display: flex;
    align-items: center;
    padding:0.15rem;
	/* box-sizing: content-box; */
	width: 100%;
}
#orderList .orders .order .orderproduct .thumb{
    width: 1.5rem;
    height: 1.5rem;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: 0.15rem;
}
#orderList .orders .order .orderproduct .thumb img {
    width: 100%;
    height: 100%;
}
#orderList .orders .order .orderproduct .info {
    padding-left: 0.3rem;
    flex-grow: 2;
    font-size: 0.3rem;
}
#orderList .orders .order .orderproduct .info .name {
    font-weight: bold;
}
#orderList .orders .order .orderproduct .info .time {
    font-size: 0.24rem;
    color: #999;
    padding: 0.1rem 0 0.2rem 0;
}
#orderList .orders .order .orderproduct .info .price span {
    font-size: 0.24rem;
}
#orderList .orders .order .btns {
    /* text-align: right; */
    display: flex;
    /* justify-content: space-between; */
    flex-direction: row-reverse;
    padding-top: 0.2rem;

}
#orderList .orders .order .btns .app-btn {
    width: 1.8rem;
    line-height: 0.55rem;
    height:0.55rem;
    font-size: 0.24rem;
    margin-left: 0.4rem;
}
#orderList .orders .order .btns .app-btn {
    border: 1px solid #C25E4D;
}
#orderList .orders .order .btns .btn-normal {
    border-color: #C1C1C1;
    background: #fff;
    color: #333;
}
#orderList .showBottomBox{
  width: 5rem;
  margin:0 auto 1rem;
  height: 0.3rem;
  font-size: 0.24rem;
  color: #BFBEBF;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}
#orderList .showBottom{
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  flex: 1;
}
#orderList .showBottomafter{
    height: 0.05rem;
    width: 1rem;
    margin-top: 0.125rem;
    background: #E8E8E6;
}
#orderList .nullBox{
  height: 4rem;
  margin-bottom: 0.4rem;
  transition: all .8s;
}
#orderList .activeNull{
  height: 0px !important;
  margin-bottom: 0 !important;
}

#orderList .noOrder {
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(220,207,191,0.6);
    border-radius: 0.1rem;
    position: relative;
    text-align: center;
	width:5.5rem;
	box-sizing: border-box;
    padding: 0.4rem;
    margin: 3rem auto;
}

#orderList .noOrderTitle{
    font-size: 0.42rem;
    font-weight: bold;
    padding: 0.3rem 0;
}
#orderList .noOrderMsg {
	font-size: 0.24rem;
    color: #505050;
	margin-bottom:0.5rem;
}



</style>